<!-- Tutorial Home Page -->
<template>
  <section class="app-docs-menu-page">
    <DocumentHeader is-menu-page-header :border="false" class="max-lg:pb-0 max-lg:!min-h-8">
      <!-- <DocumentTitle hide-line-in-mobile>{{ config?.name }} </DocumentTitle> -->
      <div class="flex items-center">
        <GfrNewButton class="app-toggle-btn flex-shrink-0 lg:!hidden" @click="toggleDocumentMenu">
          <IconsReturn class="h-4 w-4" />
        </GfrNewButton>
        <GfrTitle
          :level="1"
          :placement="$route.params.lang === 'ar' ? 'right' : 'left'"
          class="app-docs-menu-page-title"
        >
          {{ config?.name }}
        </GfrTitle>
      </div>
    </DocumentHeader>
    <div
      v-for="(item, index) in config?.groups"
      v-show="item.documents.length > 0"
      :key="item.name"
      :class="['app-docs-menu-page-ctx']"
    >
      <!-- 分组标题 -->
      <GfrTitle class="app-docs-group-title" :level="3" :placement="$route.params.lang === 'ar' ? 'right' : 'left'">
        {{ item.name }}
        <IconsDecorLine class="app-docs-group-title-decorline" />
      </GfrTitle>
      <div class="app-docs-menu-page-list">
        <DocumentCard
          v-for="doc in item.documents"
          :key="doc.id"
          :to="`${prefixPath}/${doc.p4_id}/`"
          :tutorial-config="doc"
        />
      </div>
    </div>
  </section>
</template>
<script lang="ts" setup>
import { PropType } from 'vue'
import DocumentTitle from '@/components/common/Document/Title.vue'
import DocumentHeader from '@/components/common/Document/Header.vue'
import DocumentCard from '@/components/common/Document/Card.vue'
import { TutorialHomePageConfig } from '~/server/types'
const documentStore = useDocumentStore()
const { toggleDocumentMenu } = documentStore
defineProps({
  config: Object as PropType<TutorialHomePageConfig>,
  prefixPath: String
})
</script>
<style lang="scss" scoped>
.app-docs-menu-page-list {
  @apply grid grid-cols-3 gap-[24px] max-lg:portrait:grid-cols-1 max-2xl:grid-cols-2;
  @apply landscape:max-lg:grid-cols-3 landscape:max-lg:gap-2;
}
.app-docs-menu-page-title {
  @apply text-[30px]/[38px] font-medium uppercase;
  @apply max-lg:text-[22px]/[32px];
}
.app-docs-menu-page-ctx {
  @apply pt-8 max-lg:pt-8;
  @apply pt-4;
}
.app-docs-group-title {
  @apply relative h-8 pb-1;
  @apply mb-6 text-[20px]/[28px];
  @apply max-lg:h-6 max-lg:pb-0 max-lg:mb-[10px] max-lg:text-[16px]/[24px] max-lg:uppercase;

  &-decorline {
    @apply absolute bottom-0 ltr:left-0 rtl:right-0 h-1 w-auto rtl:-scale-x-100;
    @apply bg-no-repeat bg-left-top;
    @apply text-[#ffba00];
    @apply max-lg:h-[2px] max-lg:-bottom-[2px];
  }
}
.app-toggle-btn {
  @apply inline-flex z-10 h-8 w-8 bg-dark-background ltr:mr-2 rtl:ml-2;
}
</style>
